import { InputBalloon } from '@/deps/web';
import type { FC } from 'react';
import React from 'react';
import type { ITheme, IInputBalloon } from '@/interface';
import classnames from 'classnames';
import handleUbbTextWithV2 from '@/utils/shared/handleUbbTextWithV2';
import useDarkTheme from '@/utils/hooks/useDarkTheme';
import styles from './index.module.less';

export interface IInputBalloonWithTheme {
    theme: ITheme;
    data: IInputBalloon;
    className?: string;
    balloonClassName?: string;
    /**
     * 文本的对齐方向
     */
    align?: 'left' | 'center' | 'right';
    style?: React.CSSProperties;
}

const InputBalloonWithTheme: FC<IInputBalloonWithTheme> = (props) => {

    const balloonData = React.useCallback((data: IInputBalloon) => ({
        text: data?.text ? (
            <p
                className={ styles.desc_text }
                style={{ color: props.theme === 'dark' ? '#fff' : 'var(--font_primary)' }}
                dangerouslySetInnerHTML={{ __html: handleUbbTextWithV2(data.text, { mode: 'inline' }) }}
            >
            </p>
        ) : null,
        balloonText: data?.balloonText ? (
            <div
                dangerouslySetInnerHTML={{ __html: handleUbbTextWithV2(data.balloonText, { mode: 'normal' }) }}
            >
            </div>
        ) : null
    }), [props.theme]);

    const isDark = useDarkTheme(props.theme);

    return (
        <InputBalloon
            { ...balloonData(props.data) }
            className={ classnames(
                props.theme === 'dark' ? styles.dark :  '',
                styles.input_balloon_wrap, props.className
            ) }
            contentBackgroundColor={ isDark ? '#FFFFFF' : '#000814' }
            overlayClassName={ styles.balloon_overlay }
            balloonClassName={ styles.ballon_wrap }
            iconClassName={ styles.ballon_icon }
            style={{
                textAlign: props.align,
                ...props.style
            }}
            balloonContentClassName={ classnames(
                styles.balloon_content,
                props.theme === 'dark' ? styles.balloon_content_dark :  '',
                props.balloonClassName
            ) }
        >
        </InputBalloon>
    );
};

export default InputBalloonWithTheme;
